"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLeitungApp = exports.LeitungAppSchema = void 0;
const zod_1 = require("zod");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const Mantelwerkstoff_1 = require("../Mantelwerkstoff");
const OelBestaendigkeit_1 = require("../OelBestaendigkeit");
const UvBestaendigkeit_1 = require("../UvBestaendigkeit");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleRef_1 = require("../ArticleRef");
const ArticleType_1 = require("../ArticleType");
const LeitungPrismaSchema_1 = require("../../generated/zod/modelSchema/LeitungPrismaSchema");
const ChainflexCategorySchema_1 = require("../../generated/zod/inputTypeSchemas/ChainflexCategorySchema");
const ReadycableCategorySchema_1 = require("../../generated/zod/inputTypeSchemas/ReadycableCategorySchema");
const categoryType = ChainflexCategorySchema_1.ChainflexCategorySchema.or(ReadycableCategorySchema_1.ReadycableCategorySchema);
exports.LeitungAppSchema = LeitungPrismaSchema_1.LeitungPrismaSchema.extend({
    // ArticleType: z.literal('leitung'),
    ArticleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.leitung, { message: 'invalid ArticleType' }),
    DiscontinuedModel: zod_1.z.boolean({
        required_error: 'DiscontinuedModel is required',
        invalid_type_error: 'DiscontinuedModel must be a boolean',
    }),
    // JSON fields => ArticleRef's
    BaseArticleRef: zod_1.z.custom(ArticleRef_1.isArticleRef, { message: 'invalid ArticleRef' }).optional(),
    // JSON fields => LocalizedText's
    ArtNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    Bezeichnung: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    Leitungsaufbau: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }).optional(),
    Querschnitt: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    BusSystem: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }).optional(),
    // JSON fields => Quantities
    Aussendurchmesser: zod_1.z.custom(echain_shared_quantities_1.isLengthJson, { message: 'invalid LengthJson' }),
    BiegeradiusMin: zod_1.z.custom(echain_shared_quantities_1.isLengthJson, { message: 'invalid LengthJson' }),
    GewichtKgProKm: zod_1.z.custom(echain_shared_quantities_1.isWeightPerLengthJson, { message: 'invalid WeightPerLengthJson' }),
    Kupferzahl: zod_1.z
        .custom(echain_shared_quantities_1.isWeightPerLengthJson, { message: 'invalid WeightPerLengthJson' })
        .optional(),
    AuhiTemperaturMax: zod_1.z.custom(echain_shared_quantities_1.isTemperatureJson, { message: 'invalid TemperatureJson' }),
    AuhiTemperaturMin: zod_1.z.custom(echain_shared_quantities_1.isTemperatureJson, { message: 'invalid TemperatureJson' }),
    MainCategory: categoryType,
    Categories: categoryType.array(),
    AuhiFreitragendA: zod_1.z.custom(echain_shared_quantities_1.isAccelerationJson, { message: 'invalid AccelerationJson' }).optional(),
    AuhiFreitragendV: zod_1.z.custom(echain_shared_quantities_1.isVelocityJson, { message: 'invalid VelocityJson' }).optional(),
    VerfahrwegFreitragendMax: zod_1.z.custom(echain_shared_quantities_1.isLengthJson, { message: 'invalid LengthJson' }).optional(),
    AuhiGleitendA: zod_1.z.custom(echain_shared_quantities_1.isAccelerationJson, { message: 'invalid AccelerationJson' }).optional(),
    AuhiGleitendV: zod_1.z.custom(echain_shared_quantities_1.isVelocityJson, { message: 'invalid VelocityJson' }).optional(),
    VerfahrwegGleitendMax: zod_1.z.custom(echain_shared_quantities_1.isLengthJson, { message: 'invalid LengthJson' }).optional(),
    BeschleunigungHaengendMax: zod_1.z
        .custom(echain_shared_quantities_1.isAccelerationJson, { message: 'invalid AccelerationJson' })
        .optional(),
    GeschwindigkeitHaengendMax: zod_1.z.custom(echain_shared_quantities_1.isVelocityJson, { message: 'invalid VelocityJson' }).optional(),
    VerfahrwegHaengendMax: zod_1.z.custom(echain_shared_quantities_1.isLengthJson, { message: 'invalid LengthJson' }).optional(),
    Torsionswinkel: zod_1.z
        .custom(echain_shared_quantities_1.isAnglePerLengthJson, { message: 'invalid AnglePerLengthJson' })
        .optional(),
    // string fields => proper typed enums
    Mantelwerkstoff: zod_1.z.custom(Mantelwerkstoff_1.isMantelwerkstoff, { message: 'invalid Mantelwerkstoff' }),
    Oelbestaendigkeit: zod_1.z.custom(OelBestaendigkeit_1.isOelBestaendigkeit, { message: 'invalid OelBestaendigkeit' }),
    UVBestaendigkeit: zod_1.z.custom(UvBestaendigkeit_1.isUvBestaendigkeit, { message: 'invalid UvBestaendigkeit' }),
    // readycable specific
    Leitungslaenge: zod_1.z.custom(echain_shared_quantities_1.isLengthJson, { message: 'invalid LengthJson' }).optional(),
}).refine((chainflexApp) => {
    return chainflexApp.Categories.includes(chainflexApp.MainCategory);
}, {
    message: '"MainCategory" is not listed within the "Categories"',
});
const isLeitungApp = (whatever) => {
    var _a;
    return (_a = exports.LeitungAppSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isLeitungApp = isLeitungApp;
//# sourceMappingURL=LeitungApp.js.map